export default __webpack_public_path__ + "static/media/money_1.e85929b3.png";